import axios from "axios"
import constants from "../../../constants"
import { PracticeWithContainers, PracticeWithMwaste, PracticeWithAmalgam } from "./types"

export const getChildrenWithPharmas = async (customerNumber: string) => {
  const response = await axios.get(`${constants.ONTRAQ_API_URL}/api2/${customerNumber}/customer/children/pharma`)
  const children: PracticeWithContainers[] = response.data

  return children
}

export const getChildrenWithAmalgam = async (customerNumber: string) => {
  const response = await axios.get(`${constants.ONTRAQ_API_URL}/api2/${customerNumber}/amalgam/corp-children`)
  const children: PracticeWithAmalgam[] = response.data
  return children
}

export const getChildrenWithMwaste = async (customerNumber: string) => {
  const response = await axios.get(`${constants.ONTRAQ_API_URL}/api2/${customerNumber}/mwastes/corp-children`)
  const children: PracticeWithMwaste[] = response.data

  return children
}